import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@chancenwerk/client/components/chancen-component-auto-navigation.js';
import type { SidebarSectionDefinition } from '@chancenwerk/client/components/chancen-component-auto-navigation.js';
import '@chancenwerk/client/design/components/cr-sidebar.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import logoCW from '../assets/logo_chancenwerk_white.svg';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const version = require('../../../package.json').version;

const navigation: SidebarSectionDefinition[] = [
  { name: 'Administration', subsections: [{ name: '', links: [{ label: 'Übersicht', route: '/' }] }] },
];

/**
 * @customElement markt-component-sidebar
 */
@customElement('markt-component-sidebar')
export class AkademieComponentSidebar extends ChemistryLitElement {
  override styles() {
    return [...super.styles(), { ':host': { zIndex: '9999' } }];
  }

  override render() {
    return html` <cr-sidebar .version=${version} .logoRouteTo=${window.location.href} .imageRef=${logoCW}>
      <cr-flex slot="logo" padding="md" ${css({ cursor: 'pointer' })}>
        <cr-h4 ${css({ color: 'white' })}>CHANCENcredits</cr-h4>
      </cr-flex>

      <chancen-component-auto-navigation .sections=${navigation}> </chancen-component-auto-navigation>
    </cr-sidebar>`;
  }
}
